import React, { Component } from "react";
import PropTypes from "prop-types";

import { Checkbox } from "../../../../../components/simple";

import dropDownIndicator from "../../../../../assets/images/arrow-down-blue.svg";

import styles from "./category.module.scss";

class Category extends Component {
  constructor(props) {
    super(props);

    this.state = {
      categoryCollapsed: false
    };
  }

  toggleCollapse = () => {
    const { categoryCollapsed } = this.state;
    this.setState({ categoryCollapsed: !categoryCollapsed });
  };

  render() {
    const { categoryCollapsed } = this.state;
    const {
      category = {},
      subcategories = [],
      subcategorySelect = () => {},
      selectedSubcategories = []
    } = this.props;

    return (
      <>
        {subcategories.length ? (
          <div className={styles["category-wrapper"]}>
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
            <div
              className={styles["category-header"]}
              onClick={this.toggleCollapse}
            >
              <div
                className={`${styles["category-title"]} ${
                  categoryCollapsed ? styles["category-title-collapsed"] : ""
                }  `}
              >
                {category.name}
              </div>
              <div className={styles["category-toggle-icon"]}>
                <img
                  className={
                    !categoryCollapsed ? styles["icon-category-expanded"] : ""
                  }
                  src={dropDownIndicator}
                  alt="toggle"
                />
              </div>
            </div>
            <div
              className={`${styles["categories-list"]} ${
                categoryCollapsed ? styles["categories-list-collapsed"] : ""
              }`}
            >
              {subcategories && subcategories.length
                ? subcategories.map(subcategory => {
                    const isChecked =
                      selectedSubcategories.findIndex(selectedSubcategory => {
                        return selectedSubcategory.id === subcategory.id;
                      }) > -1;

                    return (
                      <div
                        className={styles.category}
                        key={`subcategory-${subcategory.id}`}
                      >
                        <Checkbox
                          label={subcategory.name}
                          idSuffix={subcategory.id}
                          checked={isChecked}
                          onChange={() => {
                            subcategorySelect(subcategory);
                          }}
                        />
                      </div>
                    );
                  })
                : null}
            </div>
          </div>
        ) : null}
      </>
    );
  }
}

Category.propTypes = {
  category: PropTypes.shape({}).isRequired,
  subcategories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  subcategorySelect: PropTypes.func.isRequired,
  selectedSubcategories: PropTypes.arrayOf(PropTypes.shape({}))
};

Category.defaultProps = {
  selectedSubcategories: []
};

export default Category;
